import { render } from "./Contract.vue?vue&type=template&id=c8384160&scoped=true"
import script from "./Contract.vue?vue&type=script&lang=js"
export * from "./Contract.vue?vue&type=script&lang=js"

import "./Contract.vue?vue&type=style&index=0&id=c8384160&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8384160"]])

export default __exports__